module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    attrs: {
      "id": _vm.id,
      "title": "Product",
      "hide-footer": "",
      "visible": _vm.shown
    },
    on: {
      "shown": _vm.reset,
      "hide": _vm.hide
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Search"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    ref: "searchTermContainer",
    staticClass: "col-8"
  }, [_c('b-form-input', {
    staticClass: "searchTerm",
    attrs: {
      "type": "text"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.fetchProducts($event)
      }
    },
    model: {
      value: (_vm.searchTerm),
      callback: function($$v) {
        _vm.searchTerm = $$v
      },
      expression: "searchTerm"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('b-button', {
    staticClass: "col",
    on: {
      "click": _vm.fetchProducts
    }
  }, [_vm._v("Search")])], 1)])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('selectable-grid', {
    attrs: {
      "rows": _vm.products.length,
      "focused": _vm.gridFocused
    },
    scopedSlots: _vm._u([
      ["default", function(grid) {
        return [_vm._l((_vm.products), function(product, index) {
          return _c('selectable-grid-row', {
            key: product.id,
            staticClass: "ProductSelectPartialView__result",
            attrs: {
              "activeRow": grid.activeRow
            },
            on: {
              "select": function () { return _vm.selectProduct(product); }
            }
          }, [_c('selectable-grid-cell', {
            staticClass: "productSelect",
            attrs: {
              "row": index,
              "activeRow": grid.activeRow
            }
          }, [_vm._v("\n              " + _vm._s(product.code) + "\n            ")]), _vm._v(" "), _c('selectable-grid-cell', {
            staticClass: "productSelect",
            attrs: {
              "row": index,
              "activeRow": grid.activeRow
            }
          }, [_vm._v("\n              " + _vm._s(product.name) + "\n            ")]), _vm._v(" "), _c('selectable-grid-cell', {
            staticClass: "productSelect",
            attrs: {
              "row": index,
              "activeRow": grid.activeRow
            }
          }, [_vm._v("\n              " + _vm._s(product.regionBasePrice) + "\n            ")])], 1)
        }), _vm._v(" "), (_vm.loading) ? _c('tr', [_c('td', {
          staticClass: "text-center",
          attrs: {
            "colspan": "3"
          }
        }, [_vm._v("Loading...")])]) : (!_vm.searchDone) ? _c('tr', [_c('td', {
          staticClass: "text-center",
          attrs: {
            "colspan": "3"
          }
        }, [_vm._v("Fill the search term above")])]) : (_vm.products.length === 0) ? _c('tr', [_c('td', {
          staticClass: "text-center",
          attrs: {
            "colspan": "3"
          }
        }, [_vm._v("No products found")])]) : _vm._e()]
      }]
    ])
  }, [_c('th', {
    slot: "header"
  }, [_vm._v("PLU")]), _vm._v(" "), _c('th', {
    slot: "header"
  }, [_vm._v("Product")]), _vm._v(" "), _c('th', {
    slot: "header"
  }, [_vm._v("Price")])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-77df2135"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/EditEvent/ProductSelect.vue
// module id = 1696
// module chunks = 1